import { SyncDevice } from './SyncDevice';

const getDeviceName = (syncDevice: SyncDevice) => {
	if (syncDevice.name) return syncDevice.name;

	return `${syncDevice.browserName} on ${syncDevice.osName}`;
}

export default getDeviceName;